<template>

<div class="head">

	<div class="head-subtitle" v-if="isProfiling">Treatment decision support</div>
	<div class="head-subtitle" v-if="isAiding && !$isPatient">Treatment discussion aid</div>
	<div class="head-title">{{ title }}</div>

	<com-info v-if="section.info" :info="section.info" />

</div>

</template>

<script>

import comInfo from './form/Info'

export default {

	props: ['section'],

	components: {
		'com-info': comInfo
	},

	computed: {

		title: function() {

			if (this.$isPatient && this.section.patient && this.section.patient.title) {
				return this.section.patient.title
			}

			return this.section.text.title

		}

	}

}

</script>

<style scoped>

.head {
	padding-bottom: 90px;
}

@media print {

	.head {
		display: none;
	}

}

.is-mobile .head {
	padding-bottom: 40px;
}

.head-subtitle {
	text-transform: uppercase;
	color: #343434;
	font-size: 20px;
	margin-bottom: 16px;
	letter-spacing: 2px;
	font-weight: 600;
}

.is-mobile .head-subtitle {
	font-size: 12px;
	line-height: 12px;
	margin-bottom: 4px;
}

.head-title {
	color: #343434;
	font-size: 36px;
	line-height: 36px;
	font-weight: 100;
	letter-spacing: 3px;
	text-transform: uppercase;
	flex-shrink: 0;
}

.is-mobile .head-title {
	font-size: 24px;
	line-height: 24px;
}

.is-dark .head-title {
	color: #fff;
}

.head-title:after {
	content: ' ';
	position: absolute;
	bottom: -26px;
	left: 0px;
	height: 4px;
	background-color: var(--primary-color);
	width: 150px;
}

.is-aiding .head-title:after {
	background-color: var(--aid-color);
}

.is-mobile .head-title:after {
	bottom: -12px;
	width: 76px;
}

</style>